export default __webpack_public_path__ + "resources/icons/d200-f83c.png";